module.exports = __webpack_public_path__ + "img/teacher01.0dbe897a.jpeg";